<script setup>
import { useI18n } from 'vue-i18n'
import TitleComponent from "@/components/TitleComponent/index.vue"
const { t } = useI18n();
import { useRouter } from 'vue-router'
const router = useRouter()
const goBack = () => {
    router.go(-1);
}
const isMobile=ref(false);//false代表pc
onMounted(() => { 
    isMobile.value = /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
      console.log('Is mobile device:', isMobile.value);
})
</script>
<template>
<div class="container">
    <TitleComponent v-if="isMobile" :title="t('setup136')"></TitleComponent>

    <div class="packContent">
    <div class="title">
        {{ $t('setup136') }}
    </div>
    <div class="company">
        {{ $t('setup178') }}
    </div>
    <div class="content">
        <p>{{ $t('setup179') }}</p>
        <p>&nbsp;{{ $t('setup180') }}</p>
        <p>&nbsp;{{ $t('setup181') }}</p>
        <p>&nbsp;{{ $t('setup182') }}</p>


    </div>
</div>
</div>
</template>
<style scoped lang='scss'>

.container{
    width: 100%;
}
.title{
    padding-top: 40px;
    color: #282828;
    font-weight: 700;
    font-size: 25px;
    padding-bottom: 16px;
}
.company{
    color: #333333;
    font-size: 16px;
}
.content{
    // padding-top: 30px;
    font-size: 14px;
    font-size: 14px;
    line-height: 30px;
}
@media (max-width: 768px) {
    .container{
        width: 100%;
    }
    .content{
        padding-top: 0px;
    }
    .packContent{
        padding: 55px 20px 100px 20px;
        .title{
            display: none;
        }
    }
    .Headline{
    padding: 8px 0px;
    font-size: 16px;
    line-height: 30px;
    color: #131926;
    font-family: Montserrat, Arial, sans-serif;
}
   
   
}
</style>